import { z } from "zod";
import { bingoTemplateSchema } from "./BingoTemplateSchema";

const bingoGameSchema = z.object({
  access: z.object({
    entity: z.string(),
    organization: z.string(),
    section: z.string(),
  }),
  id: z.string(),
  name: z.string(),
  beginDate: z.string(),
  endDate: z.string(),
  creationTime: z.string(),
  status: z.enum(["NOT_STARTED", "IN_PROGRESS", "CLOSED"]),
  drawNumbersList: z.array(z.number()),
  gridQRCodeAccess: z.string(),
  bingoTemplateId: z.string(),
  bingoTemplateSnapshot: bingoTemplateSchema,
});

export { bingoGameSchema };
